import { useState, useEffect } from 'react';

export const usePeriodCountdown = (countdownTargetTime: string) => {
	const countdownEndTime = Date.parse(`${countdownTargetTime}-04:00`);

	const getCountdownHours = () => {
		const currentTime = new Date(
			new Date().toLocaleString('en-US', { timeZone: 'Asia/Taipei' })
		).getTime();
		const millisecondsLeft = countdownEndTime - currentTime;
		const hours = Math.floor((millisecondsLeft / (1000 * 60 * 60)));
		// console.warn(`ms=${millisecondsLeft}, equals to ${hours} hours`);
		return hours < 0 ? 0 : hours;
	};

	const [countdownHours, setCountdownHours] = useState(getCountdownHours());

	useEffect(() => {
		const interval = setInterval(() => {
			setCountdownHours(getCountdownHours());
		}, 1000);
		return () => {
			clearInterval(interval);
		};
	}, [countdownEndTime]);

	return countdownHours;
};